import SidebarNavDropdown from './SidebarNavDropdown';
import SidebarNavLink from './SidebarNavLink';
import SidebarNavTitle from './SidebarNavTitle';
 import CryptoJS from 'crypto-js';
export default {
  name: 'sidebar',
  props: {

  },
  components: {
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle
  },

  data () {
    return {
       navItem:  []
     }
  },
  mounted(){
          var permissionEncrypt = window.localStorage.getItem('accesspermissiondata')
          var bytes  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          this.navItem=JSON.parse(plaintext);

          var newArr = [];
          for (var i = 0; i < this.navItem.length; i++) {
            if(this.navItem[i].ismenu===true){
              newArr[i] = {
                'children':[],
                'icons':this.navItem[i].icons,
                'id': this.navItem[i].id,
                'ismenu':this.navItem[i].ismenu,
                'name':this.navItem[i].name,
                'parentid':this.navItem[i].parentid,
                'sequence':this.navItem[i].sequence,
                'url':this.navItem[i].url
              };

              for (var j = 0; j < this.navItem[i].children.length; j++) {
                if(this.navItem[i].children[j].ismenu===true){
                  newArr[i].children.push(this.navItem[i].children[j]);
                }
              }
            }
          }
          this.navItem = newArr;
      },

  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/sidebar.js